/* Carnis – handlekurv (skuff) v1.1 (okt. 2026)
   «Legg til»-knappene i mersalget legger varen i kurven og oppdaterer skuffen med temaets egen
   cart-drawer (renderContents), på samme måte som <product-form>. Rydder også bort en misvisende
   antallsmelding fra temaets cart.js når en rabattkode deler varen i flere linjer, og flytter
   tilbudskortet til Carnis-pakken (carnis-pakke-kurv.js) opp under varelinjene. Ingen avhengigheter. */
(function () {
  'use strict';
  if (window.CarnisKurv) return;
  window.CarnisKurv = true;

  function setLoading(btn, on) {
    btn.disabled = on;
    btn.classList.toggle('is-loading', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    var sp = btn.querySelector('.loading__spinner');
    if (sp) sp.classList.toggle('hidden', !on);
  }

  function showError(btn, msg) {
    var box = btn.closest('.ckv-upsell');
    var el = box && box.querySelector('[data-ckv-error]');
    if (!el) return;
    el.textContent = msg || 'Noe gikk galt. Prøv igjen.';
    el.hidden = false;
  }

  function add(btn) {
    var drawer = document.querySelector('cart-drawer');
    var variantId = btn.getAttribute('data-ckv-add');
    if (!variantId) return;
    setLoading(btn, true);

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
    }

    // Samme hendelse som temaets produktskjema sender (for analyse)
    var deferred = null;
    try {
      var SE = window.StandardEvents || {};
      if (SE.CartLinesUpdateEvent) {
        deferred = SE.CartLinesUpdateEvent.createPromise();
        btn.dispatchEvent(new SE.CartLinesUpdateEvent({
          action: 'add', context: 'cart',
          lines: [{ merchandiseId: variantId, quantity: 1 }],
          promise: deferred.promise
        }));
      }
    } catch (e) { deferred = null; }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (deferred) try { deferred.reject(new Error(res.description || res.message)); } catch (e) {}
          setLoading(btn, false);
          showError(btn, res.description || res.message);
          return;
        }
        if (deferred) {
          fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              try { deferred.resolve({ cart: window.StandardEvents.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) }); } catch (e) {}
            })
            .catch(function () {});
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'carnis-kurv', productVariantId: variantId, cartData: res }); } catch (e) {}
        }
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        if (deferred) try { deferred.reject(new Error('Network error')); } catch (e) {}
        setLoading(btn, false);
        showError(btn);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ckv-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    add(btn);
  });

  /* Rabattkoder som «kjøp 1, få 1 gratis» deler samme vare i flere linjer. Da sammenligner temaets
     cart.js antall per linjenummer og kan vise «Du kan bare legge …» selv om kurven er riktig.
     Vi husker forventet totalantall for varianten og fjerner meldingen når kurven stemmer. */
  var expectQty = null;
  function totalFor(variantId, skipIndex) {
    var sum = 0;
    document.querySelectorAll('cart-drawer .ckv-qty__input').forEach(function (el) {
      if (el.getAttribute('data-quantity-variant-id') !== variantId) return;
      if (skipIndex && el.getAttribute('data-index') === skipIndex) return;
      sum += parseInt(el.value, 10) || 0;
    });
    return sum;
  }
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('ckv-qty__input')) return;
    var vid = el.getAttribute('data-quantity-variant-id');
    expectQty = { vid: vid, qty: totalFor(vid) };
  }, true);
  document.addEventListener('click', function (e) {
    var rb = e.target && e.target.closest ? e.target.closest('cart-drawer cart-remove-button') : null;
    var btn = rb && rb.querySelector('[data-variant-id]');
    if (!btn) return;
    var vid = btn.getAttribute('data-variant-id');
    expectQty = { vid: vid, qty: totalFor(vid, rb.getAttribute('data-index')) };
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!expectQty || !ev || ev.source !== 'cart-items' || !ev.cartData || !ev.cartData.items) return;
      var actual = 0;
      ev.cartData.items.forEach(function (i) {
        if (String(i.variant_id) === String(expectQty.vid)) actual += i.quantity;
      });
      if (actual === expectQty.qty) {
        document.querySelectorAll('cart-drawer .cart-item__error-text').forEach(function (t) { t.textContent = ''; });
      }
      expectQty = null;
    });
  }

  /* Carnis-pakken (carnis-pakke-kurv.js) legger tilbudskortet først i .drawer__footer. I denne skuffen
     flyttes kortet opp under varelinjene, der «Passer godt sammen med» står, så bunnen med sum og
     kasseknapp holder seg lav på mobil. Pakkeskriptet rydder selv bort kortet når kurven tegnes på nytt,
     og det regner ikke flyttingen som en ny tegning (bare .cpk-cart-elementer endres). */
  function placePackCard() {
    var drawer = document.querySelector('cart-drawer.ckv');
    if (!drawer) return;
    var card = drawer.querySelector('.drawer__footer > .cpk-cart__upsell');
    var form = drawer.querySelector('cart-drawer-items #CartDrawer-Form');
    if (!card || !form || !form.parentNode) return;
    form.parentNode.insertBefore(card, form.nextSibling);
  }
  function watchPackCard() {
    var drawer = document.querySelector('cart-drawer.ckv');
    if (!drawer || !('MutationObserver' in window)) return;
    new MutationObserver(placePackCard).observe(drawer, { childList: true, subtree: true });
    placePackCard();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchPackCard); else watchPackCard();
})();
